/* Khuttwa quick buy: marks the theme's quick-view window so the black-sheet look applies, and adds a close button inside it */
(function () {
  function mark() {
    document.querySelectorAll('.tingle-modal .product-quickview__content').forEach(function (c) {
      if (c.dataset.kqb) return;
      var info = c.querySelector('.product-single__information > div') || c.querySelector('.product-single__information');
      var modal = c.closest('.tingle-modal');
      if (!info || !modal) return;
      c.dataset.kqb = '1';
      info.classList.add('kbc', 'kqb');
      modal.classList.add('kqb-modal');
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'kqb-x'; x.setAttribute('aria-label', 'Close');
      x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
      x.addEventListener('click', function () { var b = modal.querySelector('.tingle-modal__close'); if (b) b.click(); });
      info.appendChild(x);
    });
  }
  var busy = false;
  new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { busy = false; mark(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  mark();
})();
